export default {
  meta: {
    title: 'Formaât - Panneau d’administration',
  },
  rest: {
    create: 'Création',
    edit: 'Édition',
    buttons: {
      edit: 'Editer',
    },
  },
  login: {
    meta: {
      title: 'Login',
      breadcrumb: 'Login',
    },
    welcome_msg: 'Connexion',
    login_form: {
      login: {
        placeholder: 'Entrez votre nom d’utilisateur',
      },
      password: {
        placeholder: 'Entrez votre mot de passe',
      },
    },
    login_err: 'Informations d’identification incorrectes',
    login_btn: 'Se connecter',
    login_tip: 'Entrez votre nom d’utilisateur et un mot de passe',
  },
  home: {
    meta: {
      title: 'Accueil',
      breadcrumb: 'Accueil',
    },
  },
  dashboard: {
    meta: {
      title: 'Dashboard',
      breadcrumb: 'Dashboard',
      tab: 'Dashboard',
    },
  },
  admin: {
    meta: {
      title: 'Administration',
      breadcrumb: 'Administration',
    },
  },
  site: {
    meta: {
      title: 'Site',
      breadcrumb: 'Site',
    },
  },
  formaat: {
    meta: {
      title: 'Formaât',
      breadcrumb: 'Formaât',
    },
  },
};
